/* eslint-disable no-unused-vars */
import store from '@/store';

export const MEASUREMENT = {
    state: {
        isMeasuring: false,
        isMeasuringArea: false,
        isMeasuringInPanorama: false,
        openedPointCloudForMeasuring: "",
    },

    mutations: {
        SET_IS_MEASUREING : (state, value) => {
            state.isMeasuring = value;
        },
        SET_IS_MEASUREING_AREA : (state, value) => {
            state.isMeasuringArea = value;
        },
        SET_IS_MEASUREING_IN_PANORAMA : (state, value) => {
            state.isMeasuringInPanorama = value;
        },
        SET_OPENED_PC_FOR_MEASURING : (state, value) => {
            state.openedPointCloudForMeasuring = value;
        }
    },

    actions: {
        CLOSE_LOADED_PC_FOR_360_MEASURING({ dispatch, commit, state, getters }) {
            let pcName = getters['GET_OPENED_PC_FOR_MEASURING'];
            if (pcName) {
                commit('SET_OPENED_PC_FOR_MEASURING', "");
                let pc = getters["getPointClouds"].find(p => p.name == pcName);
                store.state.forgeService.toggleShowingPointCloudIn3D(pc);
            }
        },
    },

    getters: {
        GET_IS_MEASUREING : (state) => {
            return state.isMeasuring;
        },
        GET_IS_MEASUREING_AREA : (state) => {
            return state.isMeasuringArea;
        },
        GET_IS_MEASUREING_IN_PANORAMA : (state) => {
            return state.isMeasuringInPanorama;
        },
        GET_OPENED_PC_FOR_MEASURING : (state) => {
            return state.openedPointCloudForMeasuring;
        }
    },
}